// Content.js

import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';

export default class Content extends Component {
    static defaultProps = {
        menu: null,
        onLogin: () => { },
        login: false
    }
    constructor(props) {
        super(props);
        this.state = {
            menu: this.props.menu,
            email: '',
            password: '',
            confirm: 'play123^',
            confirmManager: 'manager123^',
            confirmId: 'admin',
            managerId: 'user'
        }
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangePass(event) {
        this.setState({ password: event.target.value });
    }

    handleChangeEmail(event) {
        this.setState({ email: event.target.value });
    }


    handleSubmit(event) {
        if (this.state.email == this.state.confirmId || this.state.managerId) {
            if (this.state.email == this.state.confirmId) {
                if (this.state.password == this.state.confirm) {
                    this.props.onLogin(true);
                } else {
                    alert("아이디 또는 암호가 맞지 않습니다.")
                }
            } else if (this.state.email == this.state.managerId) {
                if (this.state.password == this.state.confirmManager) {
                    this.props.onLogin(false);
                } else {
                    alert("아이디 또는 암호가 맞지 않습니다.")
                }
            } else {
                alert("아이디 또는 암호가 맞지 않습니다.")
            }
        } else {
            alert("아이디 또는 암호가 맞지 않습니다.")
        }
        event.preventDefault();
    }


    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">관리자 페이지 1.0</h3>
                                </div>
                                <div className="box-body">
                                    <div className="row">
                                        {this.props.login ?
                                            <div className="col-md-8">
                                                <p>로그인 됨</p>
                                            </div>
                                            :
                                            <div className="col-md-6">

                                                <Form>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control type="email" placeholder="Enter email" value={this.state.email} onChange={this.handleChangeEmail} />
                                                        <Form.Text className="text-muted">
                                                            We'll never share your email with anyone else.
                                                </Form.Text>
                                                    </Form.Group>

                                                    <Form.Group controlId="formBasicPassword">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type="password" placeholder="Password" value={this.state.password} onChange={this.handleChangePass} />
                                                    </Form.Group>
                                                    <Button variant="primary" onClick={this.handleSubmit}>
                                                        로그인
                                            </Button>
                                                </Form>

                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                <span className="description-text">(c) PLAYCOMPANY</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Content.js